import React from 'react';
import PropTypes from 'prop-types';
import '../assets/styles/coupon-users-input.css'

const CouponUsersField = React.forwardRef(({ source, record = {} }) => {
    return (
        <div className="resultBlock">
            {record[source].length ?
                (<ul className="resultList">
                    {record[source].slice(0, 250).map((item, index) => {
                        return <li key={item + index} className="resultListItem">
                            {item}
                        </li>
                    })}
                </ul>)
                : <div className="resultText">The list of User IDs is still empty</div>
            }
        </div>
    )
})

CouponUsersField.propTypes = {
    addLabel: PropTypes.bool,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

CouponUsersField.defaultProps = {
    addLabel: true,
};

export default CouponUsersField;


// WEBPACK FOOTER //
// ./src/components/CouponUsersField.js